import { Reducer } from 'redux';
import { HomeState } from 'models';
import { HomeActionTypes } from './action-types';

const initialState: HomeState = {
  loading: true,
  cooperatives: [],
  menuConfig: [],
};

export const reducer: Reducer<HomeState> = (state = initialState, action) => {
  switch (action.type) {
    case HomeActionTypes.SET_LOADING_STATUS:
      return { ...state, loading: action.payload };
    case HomeActionTypes.SET_COOPERATIVES:
      return { ...state, cooperatives: action.payload };
    case HomeActionTypes.SET_MENU_CONFIG:
      return { ...state, menuConfig: action.payload };
    default:
      return state;
  }
};
